export default __webpack_public_path__ + "static/media/icons8-layout.1bab784c.svg";